/** @module SiteAdmin/Document/CompositeHtml */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/html/Widget",
	"csi/reflectionHints"
], function(declare,_,HtmlWidget,reflectionHints) {

	return declare(HtmlWidget, {
		/**
		 * Do not show Referenced Documents if not supported in current context
		 */
		_resolveView: function() {
			var node = this.getViewNode();
			if (node) {
				// owner should always be in cache, except when this view is attached to a fake node(example view in Camunda)
				var owner = this.cacheView.getNode(node.__Parent__);
				var viewRef = _.findWhere(this.defView.getViewRefs(), {m_id: "ReferencedDocuments"});

				if (viewRef && owner && !reflectionHints.isReferenceDocumentOwner(owner.$Type)) {
					this.defView.removeResource(viewRef);
				}
			}
			
			this.inherited(arguments);
		}
	});
});